import "./Footer.css";
import config from "../Config/Config.json";
import { FaLinkedin, FaGithub } from "react-icons/fa";

function Footer() {
    return(
        <div className="footer-div">
            <div className="footer-section">
                <div className="footer-title">Phone</div>
                <div className="footer-subtitle"><a style={{textDecoration: 'none', color: 'black'}}  href={`tel:${config.mobile}`}>{config.mobile}</a></div>
            </div>
            <div className="footer-section">
                <div className="footer-title">Email</div>
                <div className="footer-subtitle"><a style={{textDecoration: 'none', color: 'black'}} href={`mailto:${config.email}`}>{config.email}</a></div>
            </div>
            <div className="footer-section">
                <div className="footer-title">Follow Me</div>
                <div className="footer-sublinks">
                    <a href={config.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-icon">
                            <FaLinkedin size={28} color="#0077b5" />
                        </a>
                        <a href={config.github}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-icon">
                            <FaGithub size={28} color="#000" />
                    </a>
                </div>
            </div>
            <div className="footer-section">
                <div className="footer-subtitle-low">&copy; 2025 By Pratap Abhang</div>
            </div>
        </div>
    );
}

export default Footer;